import React, {useEffect, useRef, useState} from 'react';
import { Row, Col, Card, Button, Form } from 'react-bootstrap';
import {add} from '../../../lib/api/registration';
import {listUserClub} from '../../../lib/api/club';
import {format} from "date-fns";
import Select from "react-select";
import {months} from "../../../data/common";


export function Add({ initEntities, onClose, onSave }) {
  //console.log('initEntities',initEntities)
  const [entities, setEntities] = useState([]);
  const [errors, setErrors] = useState({entities_id: false})
  const [value, setValue] = useState(null);

  useEffect(() => {
    (async () => {
      console.log('entities',entities)
      const _clubs = await listUserClub()
      const _rows = _clubs.map(p => ({...p, value: p.club_id, label: p.name}));
      setEntities(_rows);
    })();
  }, []);

  const handleSubmit = async event => {
    event.preventDefault();
    const form = event.currentTarget;
    if (!validateForm(event)) return;

    const _data = {
      entities_id: form.entities_id.value
    };

    await add(_data);
    onSave();
    onClose();
  };



  const validateForm = event => {
    const form = event.currentTarget;
    const newErrors = {
      entities_id: !form.entities_id.value
    };
    setErrors(newErrors);

    if (Object.values(newErrors).some(error => error)) {
      event.stopPropagation();
      return false;
    }
    return true;
  };

  return (
      <Card>
        <Card.Body className="bg-body-tertiary">
          <Form
              method="POST"
              encType="multipart/form-data"
              noValidate
              onSubmit={handleSubmit}
          >
            <Row className="mb-3">
              <Form.Group as={Col} md="12" controlId="entities_id">
                <Form.Label>Klub</Form.Label>
                <Form.Select name="entities_id" required isInvalid={errors.entities_id}>
                  {entities.length > 1 && (
                      <option value="">Izaberi</option>
                  )}
                  {entities.map(p => (
                      <option key={p.entities_id} value={p.entities_id}>
                        {p.name}
                      </option>
                  ))}
                </Form.Select>
                <Form.Control.Feedback type="invalid">Molimo izaberite klub.</Form.Control.Feedback>
              </Form.Group>
            </Row>

            <Row className="mb-3">
              <Form.Group as={Col} md="12" controlId="name">
                <Form.Label>Naziv</Form.Label>
                <Form.Control required type="text" name="name" value={"Pristupnica – Prva registracija"} disabled  />
              </Form.Group>
            </Row>

            <Row className="mb-3">
              <Form.Group as={Col} md="6" controlId="date_created">
                <Form.Label>Datum</Form.Label>
                <Form.Control required type="text" value={format(new Date(), 'dd.MM.yyyy')} name="date_created" disabled />
              </Form.Group>
            </Row>

            <Row className="mb-3"></Row>
            <Row className="mb-3"></Row>

            <Button type="submit">Sačuvaj</Button>
          </Form>
        </Card.Body>
      </Card>
  );
}
